{
    "Profile_Dwellings_Dwelling.dwellingDetails": "FR: Dwelling Details",
    "Profile_Dwellings_Dwelling.number": "FR: Number",
    "Profile_Dwellings_Dwelling.principalUnit": "FR: Principal Unit",
    "Profile_Dwellings_Dwelling.replacementCost": "FR: Replacement Cost",
    "Profile_Dwellings_Dwelling.numberOfLossPayees": "FR: Number of Loss Payees",
    "Profile_Dwellings_Dwelling.dwellingAddress": "FR: Dwelling Address",
    "Profile_Dwellings_Dwelling.construction": "FR: Construction",
    "Profile_Dwellings_Dwelling.dwellingType": "FR: Dwelling Type",
    "Profile_Dwellings_Dwelling.yearBuilt": "FR: Year Built",
    "Profile_Dwellings_Dwelling.wallFraming": "FR: Wall Framing",
    "Profile_Dwellings_Dwelling.wallExterior": "FR: Wall Exterior",
    "Profile_Dwellings_Dwelling.roofMaterial": "FR: Roof Material",
    "Profile_Dwellings_Dwelling.roofRenovationType": "FR: Roof Renovation Type",
    "Profile_Dwellings_Dwelling.roofRenovationYear": "FR: Roof Renovation Year",
    "Profile_Dwellings_Dwelling.numberOfUnits": "FR: Number of Units",
    "Profile_Dwellings_Dwelling.numberOfStories": "FR: Number of Stories",
    "Profile_Dwellings_Dwelling.numberOfBathrooms": "FR: Number of Bathrooms",
    "Profile_Dwellings_Dwelling.totalLivingArea": "FR: Total Living Area",
    "Profile_Dwellings_Dwelling.finishedBasementPercentage": "FR: Finished Basement %",
    "Profile_Dwellings_Dwelling.occupancy": "FR: Occupancy",
    "Profile_Dwellings_Dwelling.occupancyType": "FR: Occupancy Type",
    "Profile_Dwellings_Dwelling.numberOfFamilies": "FR: Number of Families",
    "Profile_Dwellings_Dwelling.businessActivity": "FR: Business Activity",
    "Profile_Dwellings_Dwelling.smokeFree": "FR: Smoke Free",
    "Profile_Dwellings_Dwelling.electricalSystem": "FR: Electrical System",
    "Profile_Dwellings_Dwelling.wiringType": "FR: Wiring Type",
    "Profile_Dwellings_Dwelling.panelType": "FR: Panel Type",
    "Profile_Dwellings_Dwelling.strength": "FR: Strength",
    "Profile_Dwellings_Dwelling.wiringRenovationType": "FR: Wiring Renovation Type",
    "Profile_Dwellings_Dwelling.wiringRenovationYear": "FR: Wiring Renovation Year",
    "Profile_Dwellings_Dwelling.waterHeatingSystem": "FR: Water Heating System",
    "Profile_Dwellings_Dwelling.waterTankYear": "FR: Water Tank Year",
    "Profile_Dwellings_Dwelling.waterPipeMaterial": "FR: Water Pipe Material",
    "Profile_Dwellings_Dwelling.plumbingRenovationType": "FR: Plumbing Renovation Type",
    "Profile_Dwellings_Dwelling.septicTank": "FR: Septic Tank",
    "Profile_Dwellings_Dwelling.protectionSystems": "FR: Protection Systems",
    "Profile_Dwellings_Dwelling.distanceToFireHydrant": "FR: Distance to Fire Hydrant (m)",
    "Profile_Dwellings_Dwelling.distanceToFireStation": "FR: Distance to Fire Station (km)",
    "Profile_Dwellings_Dwelling.fireAlarm": "FR: Fire Alarm",
    "Profile_Dwellings_Dwelling.numberOfSmokeDetectors": "FR: Number of Smoke Detectors",
    "Profile_Dwellings_Dwelling.sprinklers": "FR: Sprinklers",
    "Profile_Dwellings_Dwelling.sprinklerCoverage": "FR: Sprinkler Coverage",
    "Profile_Dwellings_Dwelling.burglaryAlarm": "FR: Burglary Alarm",
    "Profile_Dwellings_Dwelling.waterMitigationSystems": "FR: Water Mitigation Systems",
    "Profile_Dwellings_Dwelling.heatingSystems": "FR: Heating Systems",
    "Profile_Dwellings_Dwelling.garages": "FR: Garages",
    "Profile_Dwellings_Dwelling.swimmingPools": "FR: Swimming Pools",
    "Profile_Dwellings_Dwelling.scheduledItems": "FR: Scheduled Items",
    "Profile_Dwellings_Dwelling.improvements": "FR: Improvements",
    "Profile_Dwellings_Dwelling.lossPayees": "FR: Loss Payees",
    "Profile_Dwellings_Dwelling.animals": "FR: Animals",
    "Profile_Dwellings_Dwelling.newAnimal": "FR: New Animal",
    "Profile_Dwellings_Dwelling.newHeatingSystem": "FR: New Heating System",
    "Profile_Dwellings_Dwelling.primary": "FR: Primary",
    "Profile_Dwellings_Dwelling.newWaterMitigationSystem": "FR: New Water Mitigation System",
    "Profile_Dwellings_Dwelling.newGarage": "FR: New Garage",
    "Profile_Dwellings_Dwelling.newSwimmingPool": "FR: New Swimming Pool",
    "Profile_Dwellings_Dwelling.newScheduledItem": "FR: New Scheduled Item",
    "Profile_Dwellings_Dwelling.newImprovement": "FR: New Improvement",
    "Profile_Dwellings_Dwelling.newLossPayee": "FR: New Loss Payee"
}
